import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

export default function Faqs() {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const backgroundImage = isMobile
    ? "https://geneartai.com/images/mobile1.png"
    : "https://geneartai.com/images/image1.png";

  const faqs = [
    {
      question: "Is GeneArtAI really free?",
      answer: "Yes! You receive 20 free credits upon signup. You can also earn more credits by watching short ads."
    },
    {
      question: "How do I generate an AI image?",
      answer: "Just enter your idea in the prompt box, choose resolution and settings, and click 'Generate Image'."
    },
    {
      question: "Do I need an account to use GeneArtAI?",
      answer: "Yes, you'll need to sign up with an email to track your credits and save your generated art."
    },
    {
      question: "How can I earn more credits?",
      answer: "You can watch short rewarded ads to instantly earn more credits. No payment required."
    },
    {
      question: "What happens to my generated images?",
      answer: "All your generated images are saved securely in your dashboard. Only you can access and manage them."
    },
  ];

  return (
    <div className="relative min-h-screen font-sans text-white overflow-x-hidden">
      {/* Background */}
      <div
        className="fixed inset-0 bg-cover bg-center z-0"
        style={{
          backgroundImage: `url('${backgroundImage}')`,
          backgroundAttachment: isMobile ? "scroll" : "fixed",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div className="absolute inset-0 bg-black/20" />
      </div>

      {/* Foreground */}
      <div className="relative z-10 flex flex-col min-h-screen pt-28">
        <div className="max-w-4xl mx-auto p-6 rounded-2xl bg-black/20 backdrop-blur-sm shadow-lg">
          <h1 className="text-3xl font-bold mb-6 text-center">Frequently Asked Questions</h1>
          <div className="space-y-6">
            {faqs.map((faq, idx) => (
              <div key={idx}>
                <h3 className="text-lg font-semibold text-white mb-1">{faq.question}</h3>
                <p className="text-gray-300 text-sm">{faq.answer}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Footer */}
        <footer className="text-center text-xs text-gray-300 py-6 mt-auto">
          <div>© 2025 GeneArtAI — All Rights Reserved.</div>
          <div className="mt-2">
            <Link to="/privacy-policy" className="text-gray-300 hover:text-white underline">
              Privacy Policy
            </Link>{" "}
            |{" "}
            <Link to="/terms-of-service" className="underline hover:text-white">
              Terms of Service
            </Link>
          </div>
        </footer>
      </div>
    </div>
  );
}
